import React from "react";
import { useTranslation } from "react-i18next";
const NoAttributeProvided = () => {
  const { t } = useTranslation("event_definitions");
  return /* @__PURE__ */ React.createElement("i", null, t("replay_search.not_provided"));
};
export default NoAttributeProvided;
